import React from 'react';
import './App.scss';
import Header from "./auth/Header";
import Footer from "./auth/Footer";
import IndexRoute from "./routes/IndexRoute";
import { TonConnectUIProvider } from '@tonconnect/ui-react';

function App() {
    return (
        <TonConnectUIProvider manifestUrl="https://cryptolotto777.com/tonconnect-manifest.json">
            <div className="App">
                <Header />
                <div className="app-content">
                    <IndexRoute />
                </div>
                <div className="app-footer-wrapper">
                    <Footer />
                </div>
            </div>
        </TonConnectUIProvider>
    );
}

export default App;
